import {
  agent,
  agentCallSummaryReport,

  agentMissedCallReport,

  agentMissedRate,

  agentPerfReport,

  callbackSummaryReport,
  perfReport,
  slaReport,
} from "./../../containers/ccsmodule/Reports/components/reportTypes";
import { avgWaitTime } from "../../containers/ccsmodule/Reports/components/reportTypes";
import { SupervisorReportsType } from "../action-types/supervisorReports.action.types";
import { SupervisorReportsAction } from "../actions/supervisorReports.action";
import AgentMissedCallActivity from "../../containers/ccsmodule/Reports/components/AgentReportComponents/AgentMissedCallActivity";
import { secondsInDay } from "date-fns";

interface SupervisorReportsRepoState {
  avgWait: avgWaitTime[];
  perfReport: perfReport[];
  perfReportTable: perfReport[];
  slaReport: slaReport[];
  callbackFilters: string[];
  callbackSummaryReport: callbackSummaryReport[];
  filters: { type?: string; values?: string[] };
  loader: string[],
  allAgents: agent[]
  agentCallSummaryReport: agentCallSummaryReport[]
  agentCallSummaryTypes: string[]
  agentPerfReportTypes: string[]
  agentPerfReport: agentPerfReport[],
  agentMissedCallReport: agentMissedCallReport | undefined
  agentMissedrate: agentMissedRate | null
}
const initialState: SupervisorReportsRepoState = {
  avgWait: [],
  callbackSummaryReport: [],
  perfReportTable: [],
  perfReport: [],
  slaReport: [],
  loader: [],
  callbackFilters: [],
  filters: { type: "call", values: ["total"] },
  allAgents: [],
  agentCallSummaryReport: [],
  agentCallSummaryTypes: ["in"],
  agentPerfReportTypes: ["missed"],
  agentPerfReport: [],
  agentMissedCallReport: undefined,
  agentMissedrate: null
};

const SupervisorReportsReducer = (
  state: SupervisorReportsRepoState = initialState,
  action: SupervisorReportsAction
): SupervisorReportsRepoState => {
  switch (action.type) {
    case SupervisorReportsType.SET_AVGWAIT:
      return {
        ...state,
        avgWait: action?.payload?.sort(
          (a, b) => parseInt(Object.keys(a)[0]) - parseInt(Object.keys(b)[0])
        ),
      };

    case SupervisorReportsType.SET_PERFREPORT:
      console.log(
        "action?.payload",
        action?.payload?.map((report) => {
          return report?.data?.sort((a, b) => a?.date - b?.date);
        })
      );
      return {
        ...state,
        perfReport: action.payload,
      };
    case SupervisorReportsType.SET_PERFREPORTTABLE:
      console.log(
        "action?.payload",
        action?.payload?.map((report) => {
          return report?.data?.sort((a, b) => a?.date - b?.date);
        })
      );
      return {
        ...state,
        perfReportTable: action.payload,
      };
    case SupervisorReportsType.SET_FILTERS:
      return {
        ...state,
        filters:
          action?.payload?.type && action?.payload?.values
            ? action.payload
            : action?.payload?.type
              ? { ...state.filters, type: action?.payload?.type }
              : { ...state.filters, values: action?.payload?.values },
      };

    case SupervisorReportsType.SET_SLAREPORT:
      return {
        ...state,
        slaReport: action?.payload?.sort((a, b) => parseInt(Object.keys(a)[0]) - parseInt(Object.keys(b)[0]))
      }
    case SupervisorReportsType.SETREPORTLOADER:
      console.log("laoderererer", action.payload)
      return {
        ...state,
        loader: (action?.payload?.action === "add" && !state?.loader?.includes(action?.payload?.value)) ? [...state?.loader, action?.payload?.value] : [...state.loader.filter((node) => node !== action?.payload?.value)]
      }
    case SupervisorReportsType?.SET_CALLBACKSUMMARYREPORT:
      return {
        ...state,
        callbackSummaryReport: action.payload
      }
    case SupervisorReportsType?.SET_CALLBACKFILTERS:
      return {
        ...state,
        callbackFilters: action.payload
      }
    case SupervisorReportsType?.SET_ALLAGENTS:
      return {
        ...state,
        allAgents: action?.payload
      }
    case SupervisorReportsType?.SET_AGENTCALLSUMMARYREPORT:
      return {
        ...state,
        agentCallSummaryReport: action?.payload.map((node) => {
          return {
            ...node, data: node?.data?.sort((a, b) => {
              const firstKey = parseInt(Object?.keys(a)[0])
              const secondKey = parseInt(Object?.keys(b)[0])
              return firstKey - secondKey
            })
          }
        })
      }
    case SupervisorReportsType?.SET_AGENTPERFREPORT:
      return {
        ...state,
        agentPerfReport: action?.payload.map((node) => {
          return {
            ...node, data: node?.data?.sort((a, b) => {
              const firstKey = parseInt(Object?.keys(a)[0])
              const secondKey = parseInt(Object?.keys(b)[0])
              return firstKey - secondKey
            })
          }
        })
      }
    case SupervisorReportsType?.SET_AGENTMISSEDCALLREPORT:
      console.log("agenMosdedadsafa:", action?.payload?.data?.map((node) => new Date(parseInt(Object.keys(node)[0]) * 1000)))
      return {
        ...state,
        agentMissedCallReport: {
          ...action?.payload, data: action?.payload?.data?.sort((a, b) => {
            const firstKey = parseInt(Object?.keys(a)[0]) * 1000
            const secondKey = parseInt(Object?.keys(b)[0]) * 1000
            return firstKey - secondKey

          })
        }
      }
    case SupervisorReportsType?.SET_AGENTCALLSUMMARYTYPES:
      return {
        ...state,
        agentCallSummaryTypes: action?.payload
      }
    case SupervisorReportsType?.SET_AGENTPERFREPORTTYPES:
      return {
        ...state,
        agentPerfReportTypes: action?.payload
      }
    case SupervisorReportsType?.SET_AGENTMISSEDRATE:
      return {
        ...state,
        agentMissedrate: action?.payload
      }
    case SupervisorReportsType?.SET_CLEARSTATE:
      return initialState
    default:
      return state;
  }
};

export default SupervisorReportsReducer;
